import { useEffect } from "react";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag/useFeatureFlag";
import { Flags } from "../../../feature-flags/flags";

const FAVICON_DEFAULT = "/favicon.ico";
const FAVICON_REBRAND = "/favicon-new.ico";

export const RebrandFavicon = () => {
    const { enabled } = useFeatureFlag(Flags.ENABLE_REBRAND);

    useEffect(() => {
        const favicon = document.querySelector<HTMLLinkElement>("link[rel='shortcut icon'], link[rel='icon']");
        if (!favicon) return;

        favicon.href = enabled ? FAVICON_REBRAND : FAVICON_DEFAULT;
    }, [enabled]);

    return null;
};
